import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15fdeb8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "node-configs" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Shape:", -1))
const _hoisted_3 = { class: "control" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Type: ")
const _hoisted_5 = {
  key: 0,
  class: "control"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Radius: ")
const _hoisted_7 = { class: "control" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Width: ")
const _hoisted_9 = { class: "control" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Height: ")
const _hoisted_11 = { class: "control" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Border radius: ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Stroke:", -1))
const _hoisted_14 = { class: "control" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Width: ")
const _hoisted_16 = { class: "control" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Dasharray: ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_select, {
          modelValue: _ctx.type,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.type) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "circle",
              value: "circle"
            }),
            _createVNode(_component_el_option, {
              label: "rect",
              value: "rect"
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      (_ctx.type == 'circle')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_slider, {
              modelValue: _ctx.radius,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.radius) = $event)),
              min: 10,
              max: 64,
              step: 1
            }, null, 8, ["modelValue"])
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_el_slider, {
                modelValue: _ctx.width,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.width) = $event)),
                min: 10,
                max: 64,
                step: 1
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_el_slider, {
                modelValue: _ctx.height,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.height) = $event)),
                min: 10,
                max: 64,
                step: 1
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_el_slider, {
                modelValue: _ctx.borderRadius,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.borderRadius) = $event)),
                min: 0,
                max: 16,
                step: 1
              }, null, 8, ["modelValue"])
            ])
          ], 64))
    ]),
    _hoisted_13,
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode(_component_el_slider, {
          modelValue: _ctx.strokeWidth,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.strokeWidth) = $event)),
          min: 0,
          max: 16,
          step: 1
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createVNode(_component_el_input, {
          modelValue: _ctx.strokeDasharray,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.strokeDasharray) = $event))
        }, null, 8, ["modelValue"])
      ])
    ])
  ]))
}